
<template>
    
<div>
    <link rel="canonical" :href="this.canonical">

    <meta name="description" :content="this.description">
    
    <meta property="og:url" content="https://thejobtap.com/">
    <meta property="og:title" :content="this.title">
    <meta property="og:type" content="website">
    <meta property="og:description" :content="this.description">
    <meta property="og:image" content="https://imagedelivery.net/EWJlSj3VmuhdddwuuB6Q0A/d3717885-7e3a-4baf-4b4f-de0e5993cc00/public">
    <meta property="og:site_name" content="thejobtap.com">
        
    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:site" content="@thejobtap">
    <meta name="twitter:title" :content="this.title">
    <meta name="twitter:description" :content="this.description">
    <meta name="twitter:image" content="https://imagedelivery.net/EWJlSj3VmuhdddwuuB6Q0A/d3717885-7e3a-4baf-4b4f-de0e5993cc00/public">
</div>

</template>

<script>
export default {
  props: ["title", "description"],
  components: {
  },
  data () {
    return {
        canonical: window.location.href.split('?')[0].toLocaleLowerCase()
    }
  },
  methods: {

  },
  computed: {
    
  },
  mounted() {
    
  }
}
</script>
